
@if (taskGroup != null) {
  <div class="pc-tg">

    <!-- ── Header ──────────────────────────────────────────────────────── -->
    <header class="pc-tg-header">
      <button class="pc-tg-back" (click)="returnToList()" title="Back to Task Groups">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div class="pc-tg-title">
        <div class="pc-tg-name-row">
          <span class="pc-tg-dot" [style.background]="taskGroup.color ? taskGroup.color : '#9aa39d'"></span>
          @if (canEdit) {
            <input class="pc-tg-name-input" type="text" placeholder="Task group name"
              [(ngModel)]="taskGroup.name" (keyup.enter)="saveName($event)" title="Rename this task group">
          } @else {
            <h2 class="pc-tg-name">{{ taskGroup.name }}</h2>
          }
        </div>
        <div class="pc-tg-meta">
          @if (templateUsedForGroup != null) {
            <a class="pc-tg-meta-item pc-tg-link" (click)="navigateToTemplateDetails()" title="Open template">
              <mat-icon>description</mat-icon>
              <span>{{ templateUsedForGroup.name }}</span>
            </a>
          }
          @if (startDate != null) {
            <span class="pc-tg-meta-item" title="First task">
              <mat-icon>schedule</mat-icon>
              <span>Starts {{ startDate.seconds * 1000 | date:'MM/dd/yyyy' }}</span>
            </span>
          }
          @if (endDate != null) {
            <span class="pc-tg-meta-item" title="Last task">
              <mat-icon>flag</mat-icon>
              <span>Ends {{ endDate.seconds * 1000 | date:'MM/dd/yyyy' }}</span>
            </span>
          }
        </div>
      </div>

      <div class="pc-tg-actions">
        @if ((canEdit || canCompleteEvent) && saveBtnEnabled) {
          <button mat-button class="pc-tg-discard" (click)="undoChanges()">Discard</button>
          <button mat-raised-button color="primary" (click)="saveChanges()">
            <mat-icon>save</mat-icon> Save
          </button>
        }
        @if (canAddEvent) {
          <button mat-raised-button color="primary" class="pc-tg-add" [matMenuTriggerFor]="addeventmenu"
            [disabled]="eventsDirty" title="Add Event">
            <mat-icon>add</mat-icon> Add Event
          </button>
        }
        @if (canEdit) {
          <button mat-raised-button class="gridbtn pc-tg-kebab" [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
        }
        <mat-menu #menu="matMenu">
          <app-task-group-delete-btn [group]="taskGroup" (doneDeleting)="backToGroupList()"></app-task-group-delete-btn>
        </mat-menu>
        <mat-menu #addeventmenu="matMenu">
          <button mat-menu-item (click)="addEvent()">
            <mat-icon>add</mat-icon>
            <span>Event</span>
          </button>
          <button mat-menu-item (click)="addEventFromLibrary()">
            <mat-icon>add_task</mat-icon>
            <span>Add From Library</span>
          </button>
        </mat-menu>
      </div>
    </header>

    <!-- ── KPI strip ───────────────────────────────────────────────────── -->
    @if (pageLoaded) {
      <section class="pc-tg-kpis">

        <div class="pc-tg-kpi" [class.pc-tg-kpi-complete]="numberOfEvents > 0 && numberOfCompletedEvents === numberOfEvents">
          <div class="pc-tg-kpi-label">Tasks</div>
          <div class="pc-tg-kpi-value">
            {{ numberOfCompletedEvents }} <span class="pc-tg-kpi-of">/ {{ numberOfEvents }}</span>
          </div>
          <div class="pc-tg-kpi-progress">
            <div class="pc-tg-kpi-progress-fill" [style.width]="percentOfEventsCompletedString"></div>
          </div>
          <div class="pc-tg-kpi-sub">
            @if (overdueCount > 0) {
              <span class="pc-tg-kpi-overdue">
                <mat-icon>error_outline</mat-icon> {{ overdueCount }} overdue
              </span>
            } @else {
              On track
            }
          </div>
        </div>

        <div class="pc-tg-kpi" [class.pc-tg-kpi-warn]="nextDueDaysDif != null && nextDueDaysDif >= 0 && nextDueDaysDif <= 7">
          <div class="pc-tg-kpi-label">Next Due</div>
          @if (nextDueDate == null) {
            <div class="pc-tg-kpi-value">All done</div>
            <div class="pc-tg-kpi-sub">Nothing outstanding</div>
          } @else {
            @if (nextDueDaysDif > 0) {
              <div class="pc-tg-kpi-value">In {{ nextDueDaysDif }} <span class="pc-tg-kpi-of">{{ nextDueDaysDif === 1 ? 'day' : 'days' }}</span></div>
            } @else if (nextDueDaysDif === 0) {
              <div class="pc-tg-kpi-value">Today</div>
            } @else {
              <div class="pc-tg-kpi-value">{{ nextDueDate.seconds * 1000 | date:'MMM d' }}</div>
            }
            <div class="pc-tg-kpi-sub">
              @if (nextDueDaysDif < 0) {
                <span class="pc-tg-kpi-overdue">
                  <mat-icon>error_outline</mat-icon> {{ nextDueDaysDifAbs }} days late
                </span>
              } @else {
                {{ nextDueDate.seconds * 1000 | date:'MM/dd/yyyy' }}
              }
            </div>
          }
        </div>

        <div class="pc-tg-kpi">
          <div class="pc-tg-kpi-label">Team</div>
          <div class="pc-tg-kpi-value">
            {{ assigneeCount }} <span class="pc-tg-kpi-of">{{ assigneeCount === 1 ? 'assignee' : 'assignees' }}</span>
          </div>
          <div class="pc-tg-kpi-sub">
            @if (unassignedCount > 0) {
              {{ unassignedCount }} {{ unassignedCount === 1 ? 'task' : 'tasks' }} unassigned
            } @else {
              Everything assigned
            }
          </div>
        </div>

        @if (showLaborTile) {
          <div class="pc-tg-kpi">
            <div class="pc-tg-kpi-label">Labor</div>
            <div class="pc-tg-kpi-value">
              {{ formatMinutes(laborSpentMinutes) }}
              @if (laborEstMinutes > 0) {
                <span class="pc-tg-kpi-of">of {{ formatMinutes(laborEstMinutes) }} est.</span>
              }
            </div>
            <div class="pc-tg-kpi-sub">across {{ laborEventCount }} {{ laborEventCount === 1 ? 'task' : 'tasks' }}</div>
          </div>
        }
      </section>
    }

    <!-- ── Events ──────────────────────────────────────────────────────── -->
    <app-event-list [collectionType]="collectionType" [collectionId]="taskGroupId"
      [collectionName]="taskGroup.name" [company]="company" (eventListChange)="eventListChange($event)">
    </app-event-list>
  </div>
}
